
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as applinkl_kMLrvYBcsnkzXdTjVDNNE15SCk5p94TLedlR8oOUUMeta } from "/app/pages/applink.vue?macro=true";
import { default as ask0Ucw6ykOR_6GHmWfAEBSOy2ZQTmEKjHye7sCOx2qms4Meta } from "/app/pages/help/ask.vue?macro=true";
import { default as enterWpOhphGvPq3V88dP3kSBc6eY7qUssUPd1ZShWjujCPIMeta } from "/app/pages/dev/enter.vue?macro=true";
import { default as _91id_93LT3NSZK_RECzAXhSYq65W6d6oPnl9ochpG1OKKyzKl8Meta } from "/app/pages/page/[id].vue?macro=true";
import { default as indexvhfhWVotO_456VvDOq_45cYkZMmeSIieYf1jIKy2UpS3yT0Meta } from "/app/pages/auth/index.vue?macro=true";
import { default as index8_45YXU8kv2TXBFC5ALhjrDlmO3DYA1F8Es3FcDO0F6iMMeta } from "/app/pages/help/index.vue?macro=true";
import { default as _91id_93m762ok22FJo8b1VHyzLOTT1UMI_45Qihz9yM1ThlCPezQMeta } from "/app/pages/promo/[id].vue?macro=true";
import { default as coming_45soonlvj3jVacnIVEJwjiYqQQwU4q_45_45R2HjeDbO3dl3fofr4Meta } from "/app/pages/coming-soon.vue?macro=true";
import { default as indexPql3fcBcyljfM6GWl0nYejJmgi_sG_45S5zJ_458c1txmdsMeta } from "/app/pages/promo/index.vue?macro=true";
import { default as chatsQ_1SKz4ptxZfiyZ54my__oVaU81SRRdfwhrsZZlkOVUMeta } from "/app/pages/office/chats.vue?macro=true";
import { default as indexQU_45CXRCqw37_45lswy8pdjTWXJl22ZBV5vzxWcPMzYdkYMeta } from "/app/pages/office/index.vue?macro=true";
import { default as order_45createBsHqD_Ci3sfPhXR_45O9Jv28ZTmq1XMl2wTHVdxuMSEYEMeta } from "/app/pages/order-create.vue?macro=true";
import { default as indexHZ4lXKkVS5NgGbGbELb6urkpgpVI4ddFmaEOpYlDLooMeta } from "/app/pages/aboutUs/index.vue?macro=true";
import { default as indexF1_dP0HECEkwEGBm1Z_45T81DlZYXsU7etJSP2_45qEb5OEMeta } from "/app/pages/catalog/index.vue?macro=true";
import { default as indexo2_aOKOa6D1FHFGPVtcTzIIV5UU4oyTg8ow_45uVzF3EgMeta } from "/app/pages/contacts/index.vue?macro=true";
import { default as indexkM1zoLU5_45yvFIVKrWRqf3RxdjKnu7_BVjXcCIIhgcpEMeta } from "/app/pages/jobtoken/index.vue?macro=true";
import { default as indexF42lLgdnpk7rePIfLgTEMgLvNOkGnNtIerXN4JS0KXoMeta } from "/app/pages/office/profile/index.vue?macro=true";
import { default as billing3qvz3JqiuWBcrG76casXawpi6yLsR0ZkuBlEJ9rx6SQMeta } from "/app/pages/office/profile/billing.vue?macro=true";
import { default as privacy_45securitytuUitVjdkRfN1_nuW7i6aLNOuN4DcfYtOX3UbQHcVCIMeta } from "/app/pages/office/profile/privacy-security.vue?macro=true";
import { default as notification_45settingsHA1VO8pKrEkpgwHt9oi_PGrQ063SbXqDZ2_45mOZk1CZAMeta } from "/app/pages/office/profile/notification-settings.vue?macro=true";
import { default as profile_45IMBObZu7c708a1Mil8prMfsAw5hpkeBsGg1AzmrjrYMeta } from "/app/pages/office/profile.vue?macro=true";
import { default as resultjY0vaHVeakZNImSgD9Znuk_URdSLH2qYg7pHxQ_LNZ0Meta } from "/app/pages/payment/result.vue?macro=true";
import { default as thankyoun6OiBsqs1E0XR0SLHQ1cUy0uflGztE5equy8U_45A_BlsMeta } from "/app/pages/promo/thankyou.vue?macro=true";
import { default as indexA8_45z_45n_yWHhPFN2KXxp3HfGYY0DqW0P9ttLQ4_5oopQMeta } from "/app/pages/help/[id]/index.vue?macro=true";
import { default as jobtokenG8lFibNz_457IxSZ_45co_45KvxTn7bl4uPfUviQoK1iGwqi8Meta } from "/app/pages/office/jobtoken.vue?macro=true";
import { default as _91id_93xdo9Qa_45H65yH0JQAShfQYsBElgnQyJ4x5BAad3Nimb0Meta } from "/app/pages/help/ticket/[id].vue?macro=true";
import { default as portfolioxt1iGONjuHCESINvwHwAd7mRAxoTJ_45Gkm9sH1m447KIMeta } from "/app/pages/office/portfolio.vue?macro=true";
import { default as promotionli89k5TX9J1a5Rd_45bjBvPXg7N8VgetaC2YxlV869U6wMeta } from "/app/pages/office/promotion.vue?macro=true";
import { default as create_45ticketrTbaOu3aHH2LLraSfGsBw583PulPR1eXrcuK4XAjqasMeta } from "/app/pages/help/create-ticket.vue?macro=true";
import { default as task_45archiveM4hdtZumSmBGrqcp0gj6a9bh7jL5mzCcUBsPZ5Qn_45isMeta } from "/app/pages/office/task-archive.vue?macro=true";
import { default as index5lykB2bFcFDJ0jPYSaWSjcnHJKnj2w2DRIodDZ2JsoYMeta } from "/app/pages/create-account/index.vue?macro=true";
import { default as orders_45archiveBQhu1htxR3y2uUb_U4SjoJoQOHGgy_45HxuFAA0fv9LAsMeta } from "/app/pages/office/orders-archive.vue?macro=true";
import { default as _91slug_93LIHBgE3KdVvdAlizP_454HkLnDBZ8T8547D0oA_45ekD7OAMeta } from "/app/pages/tasks/category/[slug].vue?macro=true";
import { default as _91id_93HlaZ4N6QPi3Op34EImUSo_45kBWr4byGP5hz1BkX_45QgycMeta } from "/app/pages/catalog/portfolio/[id].vue?macro=true";
import { default as _91slug_93Qz2_rayOMz9lCgmFZKYaJ5q8ErsnB7evZbNHDD8BOdgMeta } from "/app/pages/catalog/category/[slug].vue?macro=true";
import { default as _91id_93auySDvpz5fA0WkRrp5gV0limOukBY8SeezsLLADL1C0Meta } from "/app/pages/office/task-search/[id].vue?macro=true";
import { default as indexQ_V8nSuNCAv_45Zcp8XRtQZDb4Uty9PARolwSmXO6Vk_45oMeta } from "/app/pages/office/task-search/index.vue?macro=true";
import { default as _91article_932oWDd7YX1nBLqDdBhHIJNyQc5Lfstdtik2mXi_IsPkAMeta } from "/app/pages/help/[id]/article/[article].vue?macro=true";
import { default as _91slug_932P3y1jgO6YYCcjVJb8fce4RgLM8VC_455SufOVq9DhAPMMeta } from "/app/pages/tasks/category/[city]/[slug].vue?macro=true";
import { default as _91slug_93HgWnox2fargQfaaHuTgOHGII8jmxPiwsDhzFWKfH8k4Meta } from "/app/pages/catalog/category/[city]/[slug].vue?macro=true";
export default [
  {
    name: "home",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "applink",
    path: "/applink",
    meta: applinkl_kMLrvYBcsnkzXdTjVDNNE15SCk5p94TLedlR8oOUUMeta || {},
    component: () => import("/app/pages/applink.vue")
  },
  {
    name: "faq_ask",
    path: "/help/ask",
    meta: ask0Ucw6ykOR_6GHmWfAEBSOy2ZQTmEKjHye7sCOx2qms4Meta || {},
    component: () => import("/app/pages/help/ask.vue")
  },
  {
    name: "dev-enter",
    path: "/dev/enter",
    meta: enterWpOhphGvPq3V88dP3kSBc6eY7qUssUPd1ZShWjujCPIMeta || {},
    component: () => import("/app/pages/dev/enter.vue")
  },
  {
    name: "page-id",
    path: "/page/:id()",
    component: () => import("/app/pages/page/[id].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexvhfhWVotO_456VvDOq_45cYkZMmeSIieYf1jIKy2UpS3yT0Meta || {},
    component: () => import("/app/pages/auth/index.vue")
  },
  {
    name: "faq",
    path: "/help",
    meta: index8_45YXU8kv2TXBFC5ALhjrDlmO3DYA1F8Es3FcDO0F6iMMeta || {},
    component: () => import("/app/pages/help/index.vue")
  },
  {
    name: "promo-id",
    path: "/promo/:id()",
    meta: _91id_93m762ok22FJo8b1VHyzLOTT1UMI_45Qihz9yM1ThlCPezQMeta || {},
    component: () => import("/app/pages/promo/[id].vue")
  },
  {
    name: "coming-soon",
    path: "/coming-soon",
    meta: coming_45soonlvj3jVacnIVEJwjiYqQQwU4q_45_45R2HjeDbO3dl3fofr4Meta || {},
    component: () => import("/app/pages/coming-soon.vue")
  },
  {
    name: "promo",
    path: "/promo",
    meta: indexPql3fcBcyljfM6GWl0nYejJmgi_sG_45S5zJ_458c1txmdsMeta || {},
    component: () => import("/app/pages/promo/index.vue")
  },
  {
    name: "office_chats",
    path: "/office/chats",
    meta: chatsQ_1SKz4ptxZfiyZ54my__oVaU81SRRdfwhrsZZlkOVUMeta || {},
    component: () => import("/app/pages/office/chats.vue")
  },
  {
    name: "office",
    path: "/office",
    meta: indexQU_45CXRCqw37_45lswy8pdjTWXJl22ZBV5vzxWcPMzYdkYMeta || {},
    component: () => import("/app/pages/office/index.vue")
  },
  {
    name: "order_create",
    path: "/order-create",
    meta: order_45createBsHqD_Ci3sfPhXR_45O9Jv28ZTmq1XMl2wTHVdxuMSEYEMeta || {},
    component: () => import("/app/pages/order-create.vue")
  },
  {
    name: "aboutUs",
    path: "/aboutUs",
    component: () => import("/app/pages/aboutUs/index.vue")
  },
  {
    name: "catalog",
    path: "/catalog",
    component: () => import("/app/pages/catalog/index.vue")
  },
  {
    name: "contacts",
    path: "/contacts",
    component: () => import("/app/pages/contacts/index.vue")
  },
  {
    name: "jobtoken",
    path: "/jobtoken",
    meta: indexkM1zoLU5_45yvFIVKrWRqf3RxdjKnu7_BVjXcCIIhgcpEMeta || {},
    component: () => import("/app/pages/jobtoken/index.vue")
  },
  {
    name: profile_45IMBObZu7c708a1Mil8prMfsAw5hpkeBsGg1AzmrjrYMeta?.name,
    path: "/office/profile",
    meta: profile_45IMBObZu7c708a1Mil8prMfsAw5hpkeBsGg1AzmrjrYMeta || {},
    component: () => import("/app/pages/office/profile.vue"),
    children: [
  {
    name: "office_profile",
    path: "",
    meta: indexF42lLgdnpk7rePIfLgTEMgLvNOkGnNtIerXN4JS0KXoMeta || {},
    component: () => import("/app/pages/office/profile/index.vue")
  },
  {
    name: "office_profile_billing",
    path: "billing",
    meta: billing3qvz3JqiuWBcrG76casXawpi6yLsR0ZkuBlEJ9rx6SQMeta || {},
    component: () => import("/app/pages/office/profile/billing.vue")
  },
  {
    name: "office_profile_privacy_security",
    path: "privacy-security",
    meta: privacy_45securitytuUitVjdkRfN1_nuW7i6aLNOuN4DcfYtOX3UbQHcVCIMeta || {},
    component: () => import("/app/pages/office/profile/privacy-security.vue")
  },
  {
    name: "office_profile_notification_settings",
    path: "notification-settings",
    meta: notification_45settingsHA1VO8pKrEkpgwHt9oi_PGrQ063SbXqDZ2_45mOZk1CZAMeta || {},
    component: () => import("/app/pages/office/profile/notification-settings.vue")
  }
]
  },
  {
    name: "payment-result",
    path: "/payment/result",
    meta: resultjY0vaHVeakZNImSgD9Znuk_URdSLH2qYg7pHxQ_LNZ0Meta || {},
    component: () => import("/app/pages/payment/result.vue")
  },
  {
    name: "promo-thankyou",
    path: "/promo/thankyou",
    meta: thankyoun6OiBsqs1E0XR0SLHQ1cUy0uflGztE5equy8U_45A_BlsMeta || {},
    component: () => import("/app/pages/promo/thankyou.vue")
  },
  {
    name: "faq_category",
    path: "/help/:id()",
    meta: indexA8_45z_45n_yWHhPFN2KXxp3HfGYY0DqW0P9ttLQ4_5oopQMeta || {},
    component: () => import("/app/pages/help/[id]/index.vue")
  },
  {
    name: "office_jobtoken",
    path: "/office/jobtoken",
    meta: jobtokenG8lFibNz_457IxSZ_45co_45KvxTn7bl4uPfUviQoK1iGwqi8Meta || {},
    component: () => import("/app/pages/office/jobtoken.vue")
  },
  {
    name: "help_ticket",
    path: "/help/ticket/:id()",
    meta: _91id_93xdo9Qa_45H65yH0JQAShfQYsBElgnQyJ4x5BAad3Nimb0Meta || {},
    component: () => import("/app/pages/help/ticket/[id].vue")
  },
  {
    name: "office_portfolio",
    path: "/office/portfolio",
    meta: portfolioxt1iGONjuHCESINvwHwAd7mRAxoTJ_45Gkm9sH1m447KIMeta || {},
    component: () => import("/app/pages/office/portfolio.vue")
  },
  {
    name: "office_promotion",
    path: "/office/promotion",
    meta: promotionli89k5TX9J1a5Rd_45bjBvPXg7N8VgetaC2YxlV869U6wMeta || {},
    component: () => import("/app/pages/office/promotion.vue")
  },
  {
    name: "create_ticket",
    path: "/help/create-ticket",
    meta: create_45ticketrTbaOu3aHH2LLraSfGsBw583PulPR1eXrcuK4XAjqasMeta || {},
    component: () => import("/app/pages/help/create-ticket.vue")
  },
  {
    name: "office_task_archive",
    path: "/office/task-archive",
    meta: task_45archiveM4hdtZumSmBGrqcp0gj6a9bh7jL5mzCcUBsPZ5Qn_45isMeta || {},
    component: () => import("/app/pages/office/task-archive.vue")
  },
  {
    name: "create_account",
    path: "/create-account",
    meta: index5lykB2bFcFDJ0jPYSaWSjcnHJKnj2w2DRIodDZ2JsoYMeta || {},
    component: () => import("/app/pages/create-account/index.vue")
  },
  {
    name: "office_orders_archive",
    path: "/office/orders-archive",
    meta: orders_45archiveBQhu1htxR3y2uUb_U4SjoJoQOHGgy_45HxuFAA0fv9LAsMeta || {},
    component: () => import("/app/pages/office/orders-archive.vue")
  },
  {
    name: "task_category_without_city",
    path: "/tasks/category/:slug()",
    meta: { ...(_91slug_93LIHBgE3KdVvdAlizP_454HkLnDBZ8T8547D0oA_45ekD7OAMeta || {}), ...{"middleware":["redirect-city"]} },
    component: () => import("/app/pages/tasks/category/[slug].vue")
  },
  {
    name: "portfolio",
    path: "/catalog/portfolio/:id()",
    meta: _91id_93HlaZ4N6QPi3Op34EImUSo_45kBWr4byGP5hz1BkX_45QgycMeta || {},
    component: () => import("/app/pages/catalog/portfolio/[id].vue")
  },
  {
    name: "master_category_without_city",
    path: "/catalog/category/:slug()",
    meta: { ...(_91slug_93Qz2_rayOMz9lCgmFZKYaJ5q8ErsnB7evZbNHDD8BOdgMeta || {}), ...{"middleware":["redirect-city"]} },
    component: () => import("/app/pages/catalog/category/[slug].vue")
  },
  {
    name: "office_task",
    path: "/office/task-search/:id()",
    meta: _91id_93auySDvpz5fA0WkRrp5gV0limOukBY8SeezsLLADL1C0Meta || {},
    component: () => import("/app/pages/office/task-search/[id].vue")
  },
  {
    name: "office_task_search",
    path: "/office/task-search",
    meta: indexQ_V8nSuNCAv_45Zcp8XRtQZDb4Uty9PARolwSmXO6Vk_45oMeta || {},
    component: () => import("/app/pages/office/task-search/index.vue")
  },
  {
    name: "faq_article",
    path: "/help/:id()/article/:article()",
    meta: _91article_932oWDd7YX1nBLqDdBhHIJNyQc5Lfstdtik2mXi_IsPkAMeta || {},
    component: () => import("/app/pages/help/[id]/article/[article].vue")
  },
  {
    name: "task_category",
    path: "/tasks/category/:city()/:slug()",
    meta: _91slug_932P3y1jgO6YYCcjVJb8fce4RgLM8VC_455SufOVq9DhAPMMeta || {},
    component: () => import("/app/pages/tasks/category/[city]/[slug].vue")
  },
  {
    name: "master_category",
    path: "/catalog/category/:city()/:slug()",
    meta: _91slug_93HgWnox2fargQfaaHuTgOHGII8jmxPiwsDhzFWKfH8k4Meta || {},
    component: () => import("/app/pages/catalog/category/[city]/[slug].vue")
  }
]